import { render, staticRenderFns } from "./SearchWinery.vue?vue&type=template&id=1a36d8c4&scoped=true"
import script from "./SearchWinery.vue?vue&type=script&lang=js"
export * from "./SearchWinery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a36d8c4",
  null
  
)

export default component.exports